export default {
  title: 'Tilaus nro {{number}}',
  labels: {
    item: '{{count}} tuote',
    item_other: '{{count}} tuotetta',
  },
  buttons: {
    details: 'Tiedot',
  },
  fulfillment_statuses: {
    created: 'Luotu',
    reviewed: 'Tarkastettu',
    accepted: 'Hyväksytty',
    preparing: 'Valmistuu',
    ready: 'Valmis',
    on_delivery: 'Toimituksessa',
    picked: 'Noudettu',
    rejected: 'Hylätty',
  },
};
